import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import ListingRow from './ListingRow';

interface ListingsTableProps {
  listings: any[];
}

const ListingsTable: React.FC<ListingsTableProps> = ({ listings }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Image</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Vendor</TableCell>
            <TableCell>Product Type</TableCell>
            <TableCell>Price Range</TableCell>
            <TableCell>Inventory</TableCell>
            <TableCell>SKU</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listings.map((listing) => (
            <ListingRow key={listing.id} listing={listing} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ListingsTable;
